import formatSizeNames from '../utils/formatSizeNames';

const calculateInternationalSizing = (type = 'all', toSize, fromSize):void => {

  // console.log('calc', fromSize, toSize, type)
  if(toSize && fromSize && toSize === fromSize) return;

  const collectionSizeWrapper: HTMLElement = document.querySelector('[class*="size"].facet-section');
  const collectionSizeOptions = collectionSizeWrapper ? <NodeListOf<HTMLElement>>collectionSizeWrapper.querySelectorAll('.facet-block label') : [];

  const sizeOptions = new Set([
    ...(type === 'all' ? document.querySelectorAll('[data-size-text-swap]') : []),
    ...collectionSizeOptions
  ]);

  // Also update dropdown options
  const sizeDropdowns = document.querySelectorAll('[data-size-dropdown]') as NodeListOf<HTMLSelectElement>;
  sizeDropdowns.forEach(dropdown => {
    const currentValue = dropdown.value;
    Array.from(dropdown.options).forEach(option => {
      if (option.value !== 'Please Select') {
        const labelText = formatSizeNames(option.textContent, toSize, fromSize, false);
        const hasNumber = /\d/.test(labelText);
        if (hasNumber) {
          const newSize = labelText.toString();
          option.textContent = newSize === 'NaN' ? labelText : newSize;
          if (option.value === currentValue) {
            option.value = option.textContent;
            dropdown.value = option.textContent;
          } else {
            option.value = option.textContent;
          }
        }
      }
    });
  });

  sizeOptions.forEach(size => {

    const withPrefix = size.hasAttribute('data-size-with-prefix') ? true : false;

    const parent: HTMLElement = size.closest('.size-selector') || size.closest('.variant-option__option');
    let optionRadio
    if(parent) {
      optionRadio = parent ?? parent.querySelector('[data-option-select]') as HTMLInputElement;
    } else {
      optionRadio = null
    }

    const labelText =  formatSizeNames(size.innerHTML, toSize, fromSize, withPrefix)

    const hasNumber = /\d/.test(labelText) ? true : false;

    if (hasNumber) {
      const newSize = labelText.toString();

      if(optionRadio) {
        optionRadio.dataset.optionValue = newSize;
      }

      if(newSize === 'NaN') {
        size.innerHTML = labelText;
      } else {
        size.innerHTML = newSize;
      }

    }
    size.classList.add('sizes-loaded')
  })
}

export default calculateInternationalSizing